import { useUpsellTabContext } from "../../UpsellTabContext";
import { t } from "@/i18n-js/instance";
import { UPSELL_LOCALE_ROOT } from "../../constants";
import { Button } from "@circle-react-shared/uikit/Button";
import { Header } from "./Header";

export const PaywallPriceSelectionForm = () => {
  const { offerStatus, offeredPaywall } = useUpsellTabContext();

  if (!offeredPaywall) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-4">
      <Header
        offeredPaywallStatus={offerStatus || "unknown"}
        paywallName={offeredPaywall.name || offeredPaywall.display_name}
      />

      <div>
        <Button variant="circle" type="button">
          {t([UPSELL_LOCALE_ROOT, "forms.paywall_selection.customize_page"])}
        </Button>
      </div>
    </div>
  );
};
